var WhitelistedUrlParams = /** @class */ (function () {
    function WhitelistedUrlParams(element) {
        this.element = element;
        this.queryParams = new URLSearchParams(window.location.search);
    }
    WhitelistedUrlParams.prototype.hasUrlParameter = function (key) {
        return null !== this.queryParams.get(key);
    };
    /**
     * Return filters that are not managed by Admin Columns but are active
     */
    WhitelistedUrlParams.prototype.getWhitelistedParams = function () {
        var _this = this;
        var params = [
            'ac-rules', 'orderby', 'order', 's', 'post_status', 'comment_status'
        ];
        var allowedTagNames = ['SELECT', 'INPUT'];
        var siblings = Array.prototype.filter.call(this.element.parentNode.children, function (sibling) {
            return allowedTagNames.includes(sibling.tagName) && sibling !== _this.element;
        });
        siblings.forEach(function (element) {
            var name = element.getAttribute('name');
            if (_this.hasUrlParameter(name)) {
                params.push(name);
            }
        });
        // Specific ACP logic
        this.element.parentNode.querySelectorAll('.acp-range input').forEach(function (input) {
            var name = input.getAttribute('name');
            if (_this.hasUrlParameter(name)) {
                params.push(name);
            }
        });
        return params;
    };
    return WhitelistedUrlParams;
}());
export default WhitelistedUrlParams;
